import { useTranslation } from 'react-i18next'

type Options = {
  yearFormat: 'YYYY' | 'YY'
}

// Returns a date-fns format token. The public `yearFormat` option keeps its
// 'YYYY'/'YY' labels for callers; only the emitted token is date-fns ('yyyy').
export const dateFormatForLanguage = (language: string, options?: Options) => {
  const yearFormat = options?.yearFormat === 'YY' ? 'yy' : 'yyyy'

  const dateFormat = language.toLowerCase().includes('us') ? 'MM/dd' : 'dd/MM'

  return `${dateFormat}/${yearFormat}`
}

const useDateDisplayFormat = (options?: Options) => {
  const [, { resolvedLanguage }] = useTranslation()

  return dateFormatForLanguage(resolvedLanguage, options)
}

export default useDateDisplayFormat
